<app-notification-card iconName="edit_note" title="Input Required">
  @if (state() === 'resolved') {
    <span notifBadge class="notification-badge mat-font-label-sm notification-badge--success">
      <mat-icon>check_circle</mat-icon>
      Submitted
    </span>
  }
  @if (state() === 'expired') {
    <span notifBadge class="notification-badge mat-font-label-sm notification-badge--pending">
      <mat-icon>timer_off</mat-icon>
      Expired
    </span>
  }
  <!-- Engine-stamped ask context lives inside the card header while pending (HITL contract §2) -->
  @if (state() === 'pending') {
    <app-hitl-ask-context notifBadge [entry]="entry()" />
  }

  <!-- Form -->
  @if (state() === 'pending') {
    @if (isMultiline()) {
      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>{{ entry().display_text }}</mat-label>
        <textarea
          matInput
          rows="3"
          [placeholder]="entry().placeholder"
          [ngModel]="value()"
          (ngModelChange)="value.set($event)"
          (keydown.enter)="handleEnter($event)"></textarea>
      </mat-form-field>
    } @else {
      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>{{ entry().display_text }}</mat-label>
        <input
          matInput
          [type]="inputType()"
          [placeholder]="entry().placeholder"
          [ngModel]="value()"
          (ngModelChange)="value.set($event)"
          (keydown.enter)="handleEnter($event)" />
        @if (locationHint(); as hint) {
          <mat-hint>{{ hint }}</mat-hint>
        }
      </mat-form-field>
    }

    <div class="d-flex gap-2">
      <button matButton [disabled]="!canSubmit()" (click)="submit()">
        <mat-icon>send</mat-icon>
        Submit
      </button>
      <!-- Cancel as universal refusal — only for engine-stamped free-form asks (HITL contract §4) -->
      @if (canCancel()) {
        <button matButton type="button" class="hitl-cancel" (click)="cancel()">
          <mat-icon>cancel</mat-icon>
          Cancel and refuse
        </button>
      }
    </div>
  }

  <!-- Resolved -->
  @if (state() === 'resolved') {
    <span class="mat-font-body-sm mat-text-on-surface-variant">
      Submitted: <strong>{{ resolvedValue() }}</strong>
    </span>
  }

  <!-- Expired -->
  @if (state() === 'expired') {
    <div class="d-flex flex-column gap-2">
      <p class="mat-font-body-sm mb-0 mat-text-on-surface-variant">This request has expired. Click Restart to try again.</p>
      <div>
        <button matButton="outlined" (click)="restart()">
          <mat-icon>refresh</mat-icon>
          Restart
        </button>
      </div>
    </div>
  }
</app-notification-card>
